
const blogData = [
  {
    id: 1,
    title: "K2 View Point – A Breathtaking Experience",
    thumbnail: "/Pictures/Expeditions/Above8000/K2/k2.jpeg", // Add image to /public/images or use import if local
    description: "Explore the majestic viewpoint of K2 with panoramic views and thrilling adventure...",
    path: "/Blogs/K2ViewPoints"
  },
  {
    id: 2,
    title: "Exploring Baltistan Valley",
    thumbnail: "/Pictures/Blogs/KhapluFort.jpeg",
    description: "Discover ancient forts, beautiful landscapes, and unique Balti culture in Baltistan...",
    path: "/Blogs/BaltistanValley"
  },
  //   {
  //   id: 2,
  //   title: "Exploring Baltistan Valley",
  //   thumbnail: "/Pictures/Expeditions/Above8000/K2/k2.jpeg",
  //   description: "Discover ancient forts, beautiful landscapes, and unique Balti culture in Baltistan...",
  //   path: "/Blogs/BaltistanValley"
  // },
  //   {
  //   id: 2,
  //   title: "Exploring Baltistan Valley",
  //   thumbnail: "/Pictures/Expeditions/Above8000/K2/k2.jpeg",
  //   description: "Discover ancient forts, beautiful landscapes, and unique Balti culture in Baltistan...",
  //   path: "/Blogs/BaltistanValley"
  // },
  //   {
  //   id: 2,
  //   title: "Exploring Baltistan Valley",
  //   thumbnail: "/Pictures/Expeditions/Above8000/K2/k2.jpeg",
  //   description: "Discover ancient forts, beautiful landscapes, and unique Balti culture in Baltistan...",
  //   path: "/Blogs/BaltistanValley"
  // }
];

export default blogData;
